import { z } from "zod";

/**
 * LinebreakNodeSchema - Content Schema for Linebreak Node
 *
 * Linebreak nodes represent soft line breaks (Shift+Enter).
 */
export const LinebreakNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("linebreak"),
  version: z.literal(1),
  key: z.string(),
}).strict();

export type LinebreakNode = z.infer<typeof LinebreakNodeSchema>;
